import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

/**
 * Spinner w nagłówku kolumny kanbana — widoczny przy tytule podczas dociągania.
 * `border-top` w kolorze akcentu kolumny, żeby był czytelny na białym tle.
 */
export const KanbanColumnSpinner = styled.span<{ $accent?: string }>`
  display: inline-block;
  width: 14px;
  height: 14px;
  flex-shrink: 0;
  box-sizing: border-box;
  border-radius: 50%;
  border: 2px solid ${({ theme }) => (theme.mode === 'dark' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.08)')};
  border-top-color: ${({ $accent, theme }) => (
    $accent || (theme.mode === 'dark' ? '#f3f4f6' : '#374151')
  )};
  animation: ${spin} 0.65s linear infinite;
`;
